import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "../axios";
import { toast } from "react-toastify";

function ForgotPasswordScreen() {
  const [submitform, setSubmitForm] = useState(false);
  const handleForm = (e) => {
    setSubmitForm(true);
    e.preventDefault();
    const email = e.target.email.value;
    axios
      .post(
        "/auth/forgot-password",
        { email },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setSubmitForm(false);
        e.target.email.value = "";
        toast.success("We have e-mailed your password reset link!");
      })
      .catch((err) => {
        let data = err.response?.data;
        // (data);
        if (!data?.success) {
          toast.error("Error: " + (data?.error?.message || "Something went wrong"));
          setSubmitForm(false);
        }
      });
  };
  return (
    <div className="grid grid-cols-2 gap-10 w-full place-items-center h-[calc(100vh-75px)]  absolute top-[75px]">
      <div className="col-span-2 md:col-span-1 w-full h-full items-center  bg-white justify-center flex">
        <div className="flex flex-col w-[85%] md:w-[75%] lg:w-[70%] gap-5">
          {/* Avatar */}
          <div className="flex justify-center  flex-col mb-2 gap-1">
            <h2 className="text-3xl md:text-4xl">Forgot Password?</h2>
            <p className="text-gray-500 font-normal text-sm ml-1">
              To reset your password, please enter your email
            </p>
            {/* <i className="border-[#dedbf6] p-1 border-4 rounded-full fa-solid fa-circle-user text-6xl text-primary"></i> */}
          </div>

          {/* Form */}
          <form onSubmit={handleForm} className="flex flex-col w-full gap-4">
            <div className="flex flex-col gap-2">
              <label className="">Email ID</label>
              <input
                data-testid="userIdInput"
                className="bg-[#f8f8f8] font-normal border-[2.6px] border-[#efefef] placeholder:text-[#b4b4b4] placeholder:font-normal focus:!ring-primary px-3.5 py-3 rounded-md"
                type="email"
                name="email"
                required
                placeholder="Enter your email"
              />
            </div>

            {/* <div className="flex flex-col gap-2">
                            <label className="">Password</label>
                            <input data-testid="passInput" className="bg-[#f8f8f8] font-normal border-[2.6px] border-[#efefef] placeholder:text-[#b4b4b4] placeholder:font-normal px-3.5 focus:outline-0 py-3 rounded-md" type="text" placeholder="Enter your password" />
                        </div> */}
            <div className="flex flex-col w-2/5 items-center mx-auto mt-2 gap-3.5">
              <button className="bg-primary text-white px-14 py-2 rounded-md whitespace-nowrap">
                {submitform ? "Submitting..." : "Submit"}
              </button>
              <Link
                to="/"
                className="text-primary font-normal whitespace-nowrap cursor-pointer"
              >
                <i className="fa-solid fa-arrow-left mr-1.5"></i>
                Back to Login
              </Link>
            </div>
          </form>

          {/* LOGIN Buttons */}
        </div>
      </div>
      <div className="col-span-1 md:visible hidden w-full h-full md:flex justify-center items-center bg-[#efefef] shadow-lg">
        <img
          className=" w-full md:w-[75%] h-full md:object-contain object-cover"
          src="/Images/forgotImage2.svg"
          alt=""
        />
      </div>
    </div>
  );
}

export default ForgotPasswordScreen;
